import { createRoute } from '@tanstack/react-router';

import { AdminBaseRouteLayout } from '$/routes/Admin/AdminBaseRouteLayout';

export const AdminCountriesRoute = createRoute({
  getParentRoute: () => AdminBaseRouteLayout,
  path: '/admin/countries',
}).lazy(() => import('./AdminCountriesRoute.lazy').then((d) => d.Route));
